// extracted by mini-css-extract-plugin
export default {"tab":"navbar_tab__3ACUm","navbarContainer":"navbar_navbarContainer__j9VMn"};